import React from 'react';
import { Settings } from 'lucide-react';

interface HeaderProps {
  onSettingsClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onSettingsClick }) => {
  return (
    <header className="bg-white border-b border-secondary-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img src="/logo.png" alt="BNI Logo" className="max-w-[100px]" />
            <div>
              <h1 className="text-xl font-semibold text-secondary-900">
                BNI Hot Seat Identifier
              </h1>
              <p className="text-sm text-secondary-500">
                Identify top contributors and engagement leaders
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {onSettingsClick && (
              <button
                onClick={onSettingsClick}
                className="p-2 text-secondary-400 hover:text-secondary-600 transition-colors duration-200"
                title="Settings"
              >
                <Settings className="w-5 h-5" />
              </button>
            )}
            
            {/* <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-primary-700">BN</span>
              </div>
              <span className="text-sm font-medium text-secondary-700">BNI Admin</span>
            </div> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
